import { useTranslations } from '@vocab/react';
import { Box, Stack, Text } from 'braid-design-system';
import type { FC } from 'react';

import { ClockIllustration } from 'src/libs/Illustrations';

import translations from './.vocab';

export const ReferencesEmptyState: FC = () => {
  const { t } = useTranslations(translations);

  return (
    <Box display="flex" justifyContent="center">
      <Box maxWidth="small">
        <Stack space={['small', 'medium']} align="center">
          <ClockIllustration />
          <Text weight="strong">{t('No reference checks yet')}</Text>
          <Text>
            {t(
              "When a referee completes their reference check, the report will appear here. We'll email you when the report is ready.",
            )}
          </Text>
        </Stack>
      </Box>
    </Box>
  );
};
